import { useHistory } from 'react-router-dom';

const useAttendance = () => {
  const history = useHistory();

  const sendToAttendance = (dateInfo, courseId, courseThumbnail) => {
    history.push({
      pathname: '/cursos/asistencia',
      state: {
        dateInfo,
        courseId,
        courseThumbnail,
      },
    });
  };
  return { sendToAttendance };
};

export default useAttendance;
